<template>
    <div>
        <button class="h-100 btn btn-success btn-sm" @click="exportExcel()" :disabled="disabled">
            <div class="circle-loading" v-if="isLoading"></div>
            <template v-else>
                <span v-if="titleBtn">
                    <Icon icon="mdi-tray-arrow-up" /> {{titleBtn}}
                </span>
                <span v-else>excel</span>
            </template>
        </button>
        <vue-excel-xlsx
            ref="vue-excel"
            :data="listData"
            :columns="columns"
            :file-name="dateFilter"
            :sheet-name="dateFilter"
            v-show="false"
        >
        </vue-excel-xlsx>
    </div>
</template>
<script>
import moment from "moment"
export default {
    data(){
        return {
            listData: [] ,
            isLoading: false
        }
    },
    props:{
        date: String,
        name: String,
        getData: Function,
        columns: [ Array , Object ],
        disabled: {
            type: Boolean,
            default: false
        },
        titleBtn: String
        
    },
    methods:{
        async exportExcel(){
            this.loading()
            const data = await this.getData()
            if( data === false ){
                this.loading()
                return false
            }
            this.listData = data
            this.$nextTick(() => {
                const exportEXcel = this.$refs['vue-excel']
                exportEXcel.$el.click()
		    })
            this.loading()
            
        },
        loading(){
            this.isLoading = !this.isLoading
        }
    },
    computed:{
        dateFilter(){
            return this.name + ( (this.date != undefined) ? this.date : moment(new Date(), "YYYY-MM-DD").format("DD-MM-YYYY") )
        }
    }
}
</script>